import { UUID } from '@indigohive/cogfy-types'
import { useTranslation } from 'react-i18next'
import { RecordItem } from './RecordItem'
import { CollectionPageController } from '../../../../../pages/CollectionPageV2/collection-page-controller'

type Record = {
  id: UUID
  title?: string | null
}

export type RecordsMenuProps = {
  fieldId: UUID
  linkedRecords: (Record & { recordReferenceId: UUID })[]
  recordId: UUID
  unlinkedRecords: Record[]
  limit?: boolean
  controller?: CollectionPageController
}

export function RecordsMenu (props: RecordsMenuProps) {
  const {
    fieldId,
    linkedRecords,
    recordId,
    unlinkedRecords,
    limit,
    controller
  } = props

  const { t } = useTranslation()

  return (
    <>
      {!linkedRecords.length && !unlinkedRecords.length && (
        <li className="menu-title">
          {t('No records found')}
        </li>
      )}

      {linkedRecords.length > 0 && <li className="menu-title">{t('Linked records')}</li>}
      {linkedRecords.map(linkedRecord => (
        <RecordItem
          key={linkedRecord.id}
          title={linkedRecord.title}
          linked
          onClick={() => {
            if (limit && linkedRecords.length === 1) {
              controller?.onUpdateRecordReferenceClick(recordId, fieldId, linkedRecord.id, linkedRecord.recordReferenceId, linkedRecord.title ?? null)
            } else {
              controller?.onDeleteRecordReferenceClick(recordId, fieldId, linkedRecord.recordReferenceId)
            }
          }}
        />
      ))}

      {unlinkedRecords.length > 0 && <li className="menu-title">{linkedRecords.length > 0 ? t('Link another record') : t('Link a record')}</li>}
      {unlinkedRecords.map(unlinkedRecord => (
        <RecordItem
          key={unlinkedRecord.id}
          title={unlinkedRecord.title}
          linked={false}
          onClick={() => {
            if (limit && linkedRecords.length === 1) {
              controller?.onUpdateRecordReferenceClick(recordId, fieldId, unlinkedRecord.id, linkedRecords[0].id, unlinkedRecord.title ?? null)
            } else {
              controller?.onCreateRecordReferenceClick(recordId, fieldId, unlinkedRecord.id, unlinkedRecord.title ?? null)
            }
          }}
        />
      ))}
    </>
  )
}
